import React, { useEffect, useState } from "react";
import { initialsOf, resolvePhotoUrl } from "../../utils/userDisplay";
import "./Avatar.css";

// A person's photo, or their initials when there's no photo or it fails to load.
const Avatar = ({ name, photoUrl, size = 40, className = "", alt = "" }) => {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [photoUrl]);

  const src = failed ? null : resolvePhotoUrl(photoUrl);
  const style = { width: size, height: size, fontSize: Math.round(size * 0.36) };

  if (src) {
    return (
      <img
        className={`anna-avatar is-photo ${className}`}
        src={src}
        alt={alt}
        width={size}
        height={size}
        style={style}
        loading="lazy"
        decoding="async"
        onError={() => setFailed(true)}
      />
    );
  }
  return (
    <span className={`anna-avatar is-initials ${className}`} style={style} aria-hidden={alt ? undefined : "true"}>
      {initialsOf({ full_name: name })}
    </span>
  );
};

export default Avatar;
